import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Heading1Directive } from './heading1.directive';
import { Heading2Directive } from './heading2.directive';
import { Heading3Directive } from './heading3.directive';
import { Heading4Directive } from './heading4.directive';
import { BodyDirective } from './body.directive';
import { BodySmallDirective } from './body-small.directive';
import { BodyLargeDirective } from './body-large.directive';
import { BodyXLargeDirective } from './body-x-large.directive';
import { BodyDimmedDirective } from './body-dimmed.directive';
import { BodyBoldDirective } from './body-bold.directive';
import { LinkDirective } from './link.directive';

@NgModule({
  imports: [CommonModule],
  exports: [
    Heading1Directive,
    Heading2Directive,
    Heading3Directive,
    Heading4Directive,
    BodyDirective,
    BodySmallDirective,
    BodyLargeDirective,
    BodyXLargeDirective,
    BodyDimmedDirective,
    BodyBoldDirective,
    LinkDirective
  ],
  declarations: [
    Heading1Directive,
    Heading2Directive,
    Heading3Directive,
    Heading4Directive,
    BodyDirective,
    BodySmallDirective,
    BodyLargeDirective,
    BodyXLargeDirective,
    BodyDimmedDirective,
    BodyBoldDirective,
    LinkDirective
  ]
})
export class CirrusTextModule {}
